// import React from 'react';
// import SignIn from '../components/SignIn'
// import ForgetPass from '../components/signin-signup/ForgetPass';
// import { useLocation, useNavigate } from 'react-router-dom';
// import ResetPassword from '../components/signin-signup/ResetPassword';

// const Login = ({ ...props }) => {
//     const navigate = useNavigate();
//     let location = useLocation();

//     return (
//         location.pathname === "/login"
//             ? <SignIn />
//             : location.pathname === "/forget-password"
//                 ? <ForgetPass userType="user" />
//                 : <ResetPassword userType="user" type={props.type}/>
//     )
// }

// export default Login;

import React, { useEffect, useState } from "react";
import LogInBG from "../components/signin-signup/LogInBG";
import LogInForm from "../components/signin-signup/LogInForm";
import ForgetPass from "../components/signin-signup/ForgetPass";
import ResetPassword from "../components/signin-signup/ResetPassword";
import useAuth from "../hooks/useAuth";
import { useSearchParams } from "react-router-dom";
import { getSocialMediaLink } from "../utils/common";
import Swal from "sweetalert2";
import { CallAPI } from "../utils/apiActions";
import { AFFILIATE_ACTIVITY } from "../utils/APIEndPoints";
import SlashScreen from "../components/SplashScreen";
const Login = ({ ...props }) => {
  const [searchParams] = useSearchParams();
  const inviteID = searchParams.get("inviteID") || null;
  const referral = searchParams.get("referral") || null;
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    if (!!inviteID && !!referral) {
      handleAcceptInvitation();
    }
  }, [inviteID]);

  const handleAcceptInvitation = async () => {
    setLoader(true);
    let body = {
      refererCode: referral,
      inviteID: inviteID,
    };
    let response = await CallAPI(
      "USER",
      "POST",
      AFFILIATE_ACTIVITY.ACCEPT_INVITATION,
      body
    );
    setLoader(false);
    if (response.status) {
      Swal.fire(
        "You accepted the invitation. A mail has been sent to your mail id, with password for login."
      );
    }
  };

  return loader ? (
    <SlashScreen />
  ) : (
    <div id="window">
      <section className="body-wrap">
        <div className="container">
          <div className="form-grid">
            {props.type == "login" ? (
              <LogInForm inviteID={inviteID} />
            ) : props.type == "forgetPass" ? (
              <ForgetPass type={props.type} userType={props.userType} />
            ) : (
              <ResetPassword type={props.type} userType={props.userType} />
            )}
            {props.userType == "user" && <LogInBG />}
          </div>
        </div>
      </section>
      {/* End Content  */}
    </div>
  );
};

export default Login;
